

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    
    // バリエーションが切り替わったとき処理が走る
    this.addEventListener('change', this.onVariantChange);

    // サブスク項目があるときの処理
    if (document.querySelector('#productSubscriptionOpition select[name="select-selling-plan"]')) {
      // サブスク選択項目を同期させる
      document.querySelector('#productSubscriptionOpition select[name="select-selling-plan"]').addEventListener('change', function() {
        document.querySelector('#productSubscriptionOpition input[name="selling_plan"]') && (document.querySelector('#productSubscriptionOpition input[name="selling_plan"]').value = this.value);
        document.getElementById('subscriptionPrice').textContent = this.options[this.selectedIndex].dataset.price;
        document.getElementById('subscriptionDescription').textContent = this.options[this.selectedIndex].dataset.description;
        // 単品購入を選んだらギフト表示
        if (!this.value) {
          document.querySelector('.sns-gift-product-container').style.display = "block";
        } else {
          document.querySelector('.sns-gift-product-container').style.display = "none";
        }
      }, false);

      // ブラウザバック時に選択されていた値をセットしてchangeイベントを発火させる
      window.addEventListener('pageshow', function() {
        document.querySelector('select[name="select-selling-plan"]').selectedIndex = document.querySelector('select[name="select-selling-plan"]').selectedIndex;
        document.querySelector('select[name="select-selling-plan"]').dispatchEvent(new Event('change', {bubbles: true, composed: true}));
      });
    }

  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability(); // TODO: 一旦スキップしよう
    // this.removeErrorMessage(); // TODO: あとで解析

    if (!this.currentVariant) { // エラー時？
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
    //   this.updateMedia(); // TODO: できれば対応する...SKUが選ばれたらメイン画像を変える処理
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    //   this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    // selectの値でjsonと引き当てして商品SKUを探す
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    // console.log(this.currentVariant);
  }

//   updateMedia() {
//     if (!this.currentVariant) return;
//     if (!this.currentVariant.featured_media) return;

//     const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
//     mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

//     const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
//     if (!modalContent) return;
//     const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
//     modalContent.prepend(newMediaModal);
//   }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

//   updateShareUrl() {
//     const shareButton = document.getElementById(`Share-${this.dataset.section}`);
//     if (!shareButton || !shareButton.updateUrl) return;
//     shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
//   }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
    //   `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}` // TODO: OK
      `#product-form`
      ); 
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

//   updatePickupAvailability() {
//     const pickUpAvailability = document.querySelector('pickup-availability');
//     if (!pickUpAvailability) return;

//     if (this.currentVariant && this.currentVariant.available) {
//       pickUpAvailability.fetchAvailability(this.currentVariant.id);
//     } else {
//       pickUpAvailability.removeAttribute('available');
//       pickUpAvailability.innerHTML = '';
//     }
//   }

//   removeErrorMessage() {
//     const section = this.closest('section');
//     if (!section) return;

//     const productForm = section.querySelector('product-form');
//     if (productForm) productForm.handleErrorMessage(); // TODO: 
//   }

  renderProductInfo() {

    // alert("商品表示更新");
    // fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`) // TODO: ???
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const html = new DOMParser().parseFromString(responseText, 'text/html')
    //     const destination = document.getElementById(`price-${this.dataset.section}`); // TODO:
    //     const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
    //     if (source && destination) destination.innerHTML = source.innerHTML;

    //     const price = document.getElementById(`price-${this.dataset.section}`);

    //     if (price) price.classList.remove('visibility-hidden');
    //     this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    //   });

    const price = document.getElementById(`price`);
    // let price_value = (this.currentVariant.price / 100) ;
    let price_value = `¥${(this.currentVariant.price / 100).toLocaleString()}`;
    price.querySelector('.product__price-normal span').innerHTML = price_value;
    price.querySelector('.product__price-status span').innerHTML = "";
    // ギフトを表示（サブスクはギフトできない）
    document.querySelector('.sns-gift-product-container').style.display = "block";
    
    if (!this.currentVariant.available) {
        price.querySelector('.product__price-status span').innerHTML = window.variantStrings.soldOut;
    }
    
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

    this.updateSubscription(!this.currentVariant.available)

  }

  // サブスク購入オプションがあるバリエーションを選んだ場合の表示制御
  updateSubscription(disable = true) {

    if (this.currentVariant.selling_plan_allocations.length>=1 && !disable) {
      // サブスクプランをマッピングして値追加
      this.currentVariant.selling_plan_allocations.map((plan) => {
        var plan_key = this.getPlanData().map(group => {
          return group.selling_plans.find(p => {
            return plan.selling_plan_id == p.id;
          });
        })
        if (plan_key[0]) {
          plan.plan_detail = plan_key[0];
          plan.selling_plan_name = plan_key[0].name;
        }
        return plan;
      });

      var subscriptionOption = document.querySelector("#productSubscriptionOpition");
      if ( subscriptionOption ) {
        // ギフトを隠す（サブスクはギフトできない）
        document.querySelector('.sns-gift-product-container').style.display = "none";
        // 数量選択を隠す
        // document.getElementById('quantity').style.display = "none";
        // 数量1を自動選択
        document.querySelector('#quantity select').options[0].selected  = true;

        subscriptionOption.style.display = "grid";
        // subscriptionOption.querySelector('select[name="properties[発送日]"]').removeAttribute('disabled');
        subscriptionOption.querySelector('input[name="selling_plan"]').removeAttribute('disabled');
        subscriptionOption.querySelector('select[name="select-selling-plan"]').removeAttribute('disabled');

        var select = subscriptionOption.querySelector('select[name="select-selling-plan"]');
        select.innerHTML = ""

        // サブスクプランのoptionを追加する
        for (var plan of this.currentVariant.selling_plan_allocations) {
          var option = document.createElement("option");
          option.text = plan.selling_plan_name;
          option.value = plan.selling_plan_id;
          option.dataset.price = `¥${(plan.per_delivery_price / 100).toLocaleString()}`;
          option.dataset.description = plan.plan_detail.description;
          select.appendChild(option);
        }

        // 単品購入の金額optionを最後に追加する
        var option = document.createElement("option");
        option.text = "単品購入";
        option.value = "";
        option.dataset.price = `¥${(this.currentVariant.price / 100).toLocaleString()}`;
        select.appendChild(option);

        // 初期値セット1(金額)
        var first_price = this.currentVariant.selling_plan_allocations[0].per_delivery_price; // サブスクプランの1個目の金額
        // var first_price = this.currentVariant.price; //商品の金額(単品購入)
        document.getElementById('subscriptionPrice').textContent = `¥${(first_price / 100).toLocaleString()}`;
        
        // 初期値セット2(selling_plan) 初期値は単品購入なので空白
        // var input = subscriptionOption.querySelector('input[name="selling_plan"]');
        // input.value = this.currentVariant.selling_plan_allocations[0].selling_plan_id;

        // 初期値セット3 サブスク説明文
        document.getElementById('subscriptionDescription').textContent = this.currentVariant.selling_plan_allocations[0].plan_detail.description;

        if (this.currentVariant.requires_selling_plan) {
          this.toggleAddButton(false, window.variantStrings.soldOut);
        } 
      }
    } else {
      // 数量ボタンを表示
      document.getElementById('quantity').style.display = "flex";

      // サブスクリプションのみでの購入を許可されている場合、購入ボタンを押せなくする
      if (this.currentVariant.requires_selling_plan) {
        this.toggleAddButton(true, window.variantStrings.soldOut);
      }
      var subscriptionOption = document.querySelector("#productSubscriptionOpition");
      subscriptionOption.style.display = "none";
      // subscriptionOption.querySelector('select[name="properties[発送日]"]').setAttribute('disabled', "disabled");
      subscriptionOption.querySelector('input[name="selling_plan"]').setAttribute('disabled', "disabled");
      subscriptionOption.querySelector('select[name="select-selling-plan"]').setAttribute('disabled', "disabled");
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    // const productForm = document.getElementById(`product-form-${this.dataset.section}`); // TODO: OK
    const productForm = document.getElementById(`product-form`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const buynowButton = productForm.querySelector('button-buy-now');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (buynowButton) buynowButton.setAttribute('disabled', 'disabled');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (buynowButton) buynowButton.removeAttribute('disabled');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    // const button = document.getElementById(`product-form-${this.dataset.section}`); // TODO: OK
    const button = document.getElementById(`product-form`); 

    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');

    // const price = document.getElementById(`price-${this.dataset.section}`);  // TODO: OK
    const price = document.getElementById(`price`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden'); // TODO: 隠す？
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getPlanData() {
    this.planData = this.planData || JSON.parse(this.querySelector('#planData[type="application/json"]').textContent);
    return this.planData;
  }
}

customElements.define('variant-selects', VariantSelects);


class ButtonBuyNow extends HTMLElement {

  constructor() {
    super();
    this.addEventListener('click', this.onButtonClick);
  }

  onButtonClick() {
    if (this.hasAttribute('disabled')) return;

    const form = document.querySelector('product-form form');
    const id = form["id"].value;
    const selling_plan = form["selling_plan"].disabled ? "" : form["selling_plan"].value;
    const quantity = form["quantity"].value;

    const url = `/cart/clear?return_to=/cart/add?items[0][id]=${id}%26items[0][quantity]=${quantity}%26items[0][selling_plan]=${selling_plan}%26return_to=/checkout`;
    location.href = url;
  }
}
customElements.define('button-buy-now', ButtonBuyNow);

